/**
 ShapeDiver 3D Viewer Application

 THREELoader.js

 Content:
   Pseudo loader used to load THREE.Object3D objects.

  Copyright (c) 2018 ShapeDiver GmbH

  @module THREELoader
 */

var THREE = require('../../externals/three');

/**
  * Constructor of the singleton THREELoader class
  */
var THREELoader = function () {

  /**
   * Pseudo load a THREE.Object3D and apply transformations to it.
   * @param  {THREE.Object3D} threeObj - Object to load
   * @param  {THREE.Matrix4[]} [transforms] - Array of transformation matrices to be applied
   * @return {Promise<module:OutputVersion~GeometryData[]>} Definition of geometry representing the transformed objects.
   */
  this.loadGeometry = function (threeObject, transforms) {

    let outputGeometry = [];

    // check type of threeObj
    let type;
    if ( threeObject.isMesh )
      type = 'mesh';
    else if ( threeObject.isLineLoop )
      type = 'lineloop';
    else if ( threeObject.isLineSegments )
      type = 'linesegments';
    else if ( threeObject.isLine )
      type = 'line';
    else if ( threeObject.isPoints )
      type = 'points';
    else
      return Promise.reject(new Error('Unsupported type of THREE.Object3D'));

    // sanity checks for transformations
    if (!Array.isArray(transforms) ||
        transforms.length == 0 ||
        !transforms.every(function(m) {return m && m.isMatrix4;})
    ) {
      transforms = [new THREE.Matrix4()];
    }
    
    let i = 0;
    for (let t of transforms) {
      let geometryDefinition = {
        path: 'transformation_' + i,
        geometry: threeObject.geometry,
        texCoord: false, // seems to be not needed anymore
        initialMatrix: t,
        type: type
      };
      outputGeometry.push(geometryDefinition);
      ++i;
    }

    return Promise.resolve(outputGeometry);
  };
};

var THREELoaderSingleton = new THREELoader();

module.exports = THREELoaderSingleton;
